export const products = {
  oil: {
    label: 'OIL',
    value: 1,
  },
  water: {
    label: 'WATER',
    value: 2,
  },
  gas: {
    label: 'GAS',
    value: 3,
  },
}
